module.exports = __webpack_public_path__ + "static/media/img1.9e13f3a8.jpg";